import React from 'react';
import cn from 'bem-cn';

import { Stack } from '../../components/UI';
import { useGetChallengesQuery } from '../../store';
import { ChallengeCard } from '../../components/ChallengeCard/ChallengeCard';
import { BigTitleWithText } from '../../components/BigTitleWithText/BigTitleWithText';

import './ChallengeListPage.scss';

const b = cn('challenge-list-page');

export const ChallengeListPage: React.FC = () => {
    const { data, isFetching } = useGetChallengesQuery();

    return (
        <Stack className={b()}>
            <BigTitleWithText title="ДАВАЙТЕ СОРЕВНОВАТЬСЯ" text="ИИ-челленджи с реальными призами" />
            {isFetching && (
                <div style={{ textAlign: 'center', marginTop: '30vh', transform: 'translateY(-50%)' }}>Загрузка...</div>
            )}
            <div className={b('challenge-list')}>
                {data?.map(challenge => <ChallengeCard key={challenge.id} challenge={challenge} />)}
            </div>
        </Stack>
    );
};
